// Background-safe interval ticker. Browsers throttle setInterval/timeouts in hidden tabs
// (intensive throttling -> 1 tick/min after ~5 min). A Web Worker timer keeps firing on time,
// so the Live Coach keeps analyzing frames + speaking cues while the player is in their game
// and not looking at the browser tab.
export function createTicker(intervalMs, onTick) {
    try {
        const src =
            "let id=null;onmessage=function(e){" +
            "if(e.data&&e.data.cmd==='start'){clearInterval(id);id=setInterval(function(){postMessage('tick');},e.data.interval);}" +
            "else if(e.data&&e.data.cmd==='stop'){clearInterval(id);id=null;}};";
        const blob = new Blob([src], { type: "application/javascript" });
        const url = URL.createObjectURL(blob);
        const worker = new Worker(url);
        worker.onmessage = () => { try { onTick(); } catch { /* ignore */ } };
        worker.postMessage({ cmd: "start", interval: intervalMs });
        return {
            stop() {
                try { worker.postMessage({ cmd: "stop" }); worker.terminate(); } catch { /* ignore */ }
                try { URL.revokeObjectURL(url); } catch { /* ignore */ }
            },
        };
    } catch {
        // Fallback: plain setInterval (still works when tab is focused).
        const id = setInterval(() => { try { onTick(); } catch { /* ignore */ } }, intervalMs);
        return { stop() { clearInterval(id); } };
    }
}
